<template>
  <!-- position:absolute;bottom:-9999px;width:1920px;padding: 30px; -->
  <div ref="pdfTemple" style="color:#000;font-size:24px;line-height: 36px;position:absolute;bottom:-9999px;width:1920px;padding: 30px;">
    <div style="padding:50px;">
      <div class="flex-align flex-spacebetween" style="margin-bottom: 40px;">
          <img src="https://minio.wooper.com/test/11/1724383663894_16WJDALX.png" style="width:140px; height:60px;" />
          <div class="flex" style="width:56%;padding: 0px 60px 10px;border-bottom: 1px solid #000;">
              <span style="font-size: 44px;margin-right:60px">DELIVERY NOTE</span>
              <span>{{ customer.innerOrderNo }}</span>
          </div>
      </div>
      <div class="flex">
          <div style="width:50%;padding-left:10px;">
              <div style="font-size:32px">DODGE INDUSTRIAL AUSTRALIA</div>
              <div style="font-size:32px">PTY LTD</div>
              <div style="margin-bottom: 20px;">ABN 30 653 869 204</div>

              <div class="title">Bill To/Payer</div>
              <div>{{ customer.receiverName }}</div>
              <div>{{ customer.deliveryAddress1 }}</div>
              <div>{{ customer.city }}</div>
              <div>{{ customer.district }}</div>
              <div>{{ customer.country }}</div>
              <div class="title">Sold To</div>
              <div>{{ customer.receiverName }}</div>
              <div>{{ customer.deliveryAddress1 }}</div>
              <div>{{ customer.city }}</div>
              <div>{{ customer.district }}</div>
              <div>{{ customer.country }}</div>
              <div class="title">Ship To</div>
              <div>{{ customer.receiverName }}</div>
              <div>{{ customer.deliveryAddress1 }}</div>
              <div>{{ customer.city }}</div>
              <div>{{ customer.district }}</div>
              <div>{{ customer.country }}</div>
          </div>
          <div style="width:50%;">
              <div class="flex-align">
                  <div style="width:70%">Delivery Note No</div>
                  <div>{{ customer.innerOrderNo }}</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Despatch Date</div>
                  <div>{{ customer.hjShipmentTime }}</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Plant</div>
                  <div>AUZP</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Shipping Point</div>
                  <div>CSG</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Terms of Delivery</div>
                  <div>EXW NAME OF CITY</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Manner of transport</div>
                  <div>ROAD</div>
              </div>
              <div style="border:1px solid #000;margin-top: 20px;padding: 1px;">
                  <div class="flex-align">
                      <div style="width:70%">Customer PO</div>
                      <div>{{ customer.lineOrderCustomerRef }}</div>
                  </div>
                  <div>Customer Contact</div>
                  <div>Customer Reference</div>
              </div>
              <div class="flex-align">
                  <div style="width:70%">Sales Order Number</div>
                  <div>{{ customer.outerOrderNo }}</div>
              </div>
          </div>
      </div>
    </div>

    <div style="padding: 0 40px;margin-top:16px;">
      <div style="border-top:1px solid #000;padding: 20px 10px 0;border-bottom: 1px solid #000;">
        <div style="line-height:1">CONDITIONS OF SALE</div>
        <div>Unless DODGE expressly acknowledges in writing that DODGE's General Terms and Conditions of Sale have been replaced</div>
        <div>by other agreed terms and conditions, this Sales Order Acknowledgement is issued pursuant to DODGE's General Terms and</div>
        <div>Conditions of Sale which are located at https://dodgeindustrial.com/terms-conditions-usa/ or are attached to this Sales Order</div>
        <div>Acknowledgement.These General Terms and Conditions of Sale prevail over, and apply notwithstanding,any wording in any</div>
        <div>order or other communication seeking to impose the use of alternative terms and conditions.</div>
      </div>
      <div class="flex-align" style="border-bottom: 1px solid #000;margin-bottom: 10px;">
        <div style="width: 10%">Item</div>
        <div style="width: 25%">Part Number | Serial Number<br />Manufacturer Part Number<br />Part Number Customer | Description</div>
        <div style="width: 15%;">Quantity</div>
        <div style="width: 10%">Weight</div>
        <div style="width: 10%;">Unit</div>
        <div style="width: 10%;">Previous shipped qty</div>
        <div style="width: 10%;">Quantity Shipped</div>
        <div style="width: 10%;">Back Ordered</div>
      </div>
      <div v-for="(item,index) in tableList" :key="index" class="flex-align">
        <div style="width: 35%;">{{ item.skuCode }}<br />{{ item.skuName }}</div>
        <div style="width: 15%;">{{ item.quantity }}</div>
        <div style="width: 10%">{{ item.weight }}</div>
        <div style="width: 10%;">ea kg</div>
        <div style="width: 10%;">0</div>
        <div style="width: 10%;">{{ item.quantity }}</div>
        <div style="width: 10%;">0</div>
      </div>
      <div style="height:100px;border-top:1px solid #000;border-bottom:1px solid #000;margin-top:400px;">
        <div></div>
        <div>Total Weight(KG) - {{ customer.totalWeight }}</div>
      </div>
      <div>
        <div class="flex-align flex-spacebetween">
          <div>Postal Address :</div>
          <div>Website : www.dodgeindustrial.com</div>
        </div>
        <div>DODGE INDUSTRIAL AUSTRALIA PTY LTD</div>
        <div class="flex-align flex-spacebetween">
          <div>L61, 1 Farrer Place</div>
          <!-- <div>DODGE Support:</div> -->
        </div>
        <div>Sydney 2000 NSW</div>
        <div>Australia</div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

  <script>
  import html2canvas from 'html2canvas';
  import JsPDF from 'jspdf';
  import printJS from 'print-js';
  export default {
      props: {
          customer: {
              type: Object,
              default: null,
          },
          tableList: {
            type: Array,
            default: []
          }
      },
      methods: {
          renderHeader(h, { column }) {
            // 假设column.label包含换行信息，如"姓名\n（昵称）"
            const lines = column.label.split('\n');
            return h('div', {}, lines.map(line => h('div', {}, line)));
          },
          async exportPage() {
            const PDFView = this.$refs.pdfTemple;
            html2canvas(PDFView, {
              allowTaint: true,
              useCORS: true,
              dpi: 120, // 图片清晰度问题
              background: '#FFFFFF', // 如果指定的div没有设置背景色会默认成黑色,这里是个坑
            }).then(canvas => {
              // 未生成pdf的html页面高度
              var leftHeight = canvas.height;
              var a4Width = 595.28;
              var a4Height = 841.89; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
              // 一页pdf显示html页面生成的canvas高度;
              var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);

              // pdf页面偏移
              var position = 0;
              var pageData = canvas.toDataURL('image/jpeg', 1.0);
              var pdf = new JsPDF('p', 'pt', 'a4'); // A4纸，纵向
              var index = 1; var canvas1 = document.createElement('canvas'); var height;
              pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');
              let that = this;

              function createImpl(canvas) {
                console.log(leftHeight, a4HeightRef);
                if (leftHeight > 0) {
                  index++;
                  var checkCount = 0;
                  if (leftHeight > a4HeightRef) {
                    var i = position + a4HeightRef;
                    for (i = position + a4HeightRef; i >= position; i--) {
                      var isWrite = true;
                      for (var j = 0; j < canvas.width; j++) {
                        var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
                        if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                          isWrite = false;
                          break;
                        }
                      }
                      if (isWrite) {
                        checkCount++;
                        if (checkCount >= 10) {
                          break;
                        }
                      } else {
                        checkCount = 0;
                      }
                    }
                    height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                    if (height <= 0) {
                      height = a4HeightRef;
                    }
                  } else {
                    height = leftHeight;
                  }
                  canvas1.width = canvas.width;
                  canvas1.height = height;
                  console.log(index, 'height:', height, 'pos', position);
                  var ctx = canvas1.getContext('2d');
                  ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);
                  // var pageHeight = Math.round((a4Width / canvas.width) * height);
                  // pdf.setPageSize(null, pageHeight)
                  if (position != 0) {
                    pdf.addPage();
                  }
                  pdf.addImage(
                    canvas1.toDataURL('image/jpeg', 1.0), 'JPEG',
                    10, 10, a4Width, (a4Width / canvas1.width) * height
                  );
                  leftHeight -= height;
                  position += height;
                  if (leftHeight > 0) {
                    setTimeout(createImpl, 500, canvas);
                  } else {
                    pdf.save(`${that.$t('route.BusinessBillingDeliveryNote')}.pdf`);
                  }
                }
              }

              // 当内容未超过pdf一页显示的范围，无需分页
              if (leftHeight < a4HeightRef) {
                pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, (a4Width / canvas.width) * leftHeight);
                pdf.save(`${that.$t('route.BusinessBillingDeliveryNote')}.pdf`);
              } else {
                try {
                  pdf.deletePage(0);
                  setTimeout(createImpl, 500, canvas);
                } catch (err) {
                  console.log(err);
                }
              }
            });
          },
          isSplit (nodes, index, pageHeight) {
              // 计算当前这块dom是否跨越了a4大小，以此分割
              return !!(nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight);
          },
          // 导出为pdf
          exportPDF() {
              // pdfTemple ref
              const PDFView = this.$refs.pdfTemple;
              // 获取分割dom，此处为class类名为item的dom
              const lableListID = document.getElementsByClassName('emptyItem');
              const pageHeight = PDFView.scrollWidth / 841.89 * 595.28; // (横版pdf)
              // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
              for (let i = 0; i < lableListID.length; i++) {
                  const multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
                  if (this.isSplit(lableListID, i, multiple * pageHeight)) {
                      const divParent = lableListID[i].parentNode; // 获取该div的父节点
                      const newNode = document.createElement('div');
                      newNode.className = 'emptyDiv';
                      newNode.style.background = '#ffffff';
                      const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
                      console.log(pageHeight, lableListID[i].offsetTop, lableListID[i].offsetHeight);
                      newNode.style.height = _H + 'px';
                      newNode.style.width = '100%';
                      const next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
                      // 判断兄弟节点是否存在
                      if (next) {
                          // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
                          divParent.insertBefore(newNode, next);
                      } else {
                          // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
                          divParent.appendChild(newNode);
                      }
                  }
              }

              html2canvas(PDFView, {
                  useCORS: true, // 是否尝试使用CORS从服务器加载图像
                  allowTaint: true,
                  dpi: 300, // 解决生产图片模糊
                  scale: 3, // 清晰度--放大倍数
              }).then(
                  (canvas) => {
                      const contentWidth = canvas.width;
                      const contentHeight = canvas.height;
                      // let pageHeight = contentWidth / 592.28 * 841.89 // 一页pdf显示html页面生成的canvas高度;
                      const pageHeight = contentWidth / 841.89 * 595.28; // 一页pdf显示html页面生成的canvas高度(横版pdf);
                      let leftHeight = contentHeight; // 未生成pdf的html页面高度
                      let position = 0; // pdf页面偏移

                      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                      const imgWidth = 808; // 宽度（横版pdf）
                      const imgHeight = 841.89 / contentWidth * contentHeight; // （横版pdf）
                      const pageData = canvas.toDataURL('image/jpeg', 1.0);
                      const PDF = new JsPDF('l', 'pt', 'a4');
                      if (leftHeight < pageHeight) {
                          PDF.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight);
                      } else {
                          while (leftHeight > 0) {
                              PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight);
                              leftHeight -= pageHeight;
                              position -= 595.28; // (横版pdf)
                              // position -= 841.89
                              if (leftHeight > 0) {
                                  PDF.addPage();
                              }
                          }
                      }
                      PDF.save('b.pdf'); // 下载标题
                      // // 将前面处理内容分割问题在页面中加上的空白占位结点去掉
                      const emptyDiv = document.getElementsByClassName('emptyDiv');
                      for (let i = 0; i < emptyDiv.length; i++) {
                          emptyDiv[i].remove();
                          i = i - 1;
                      }
              });
          },
          goPrint() {
              html2canvas(this.$refs.pdfTemple, {
                  allowTaint: true,
                  taintTest: false,
                  useCORS: true,
                  dpi: window.devicePixelRatio * 4,
                  scale: 4,
                  logging: true, // 日志开关，便于查看html2canvas的内部执行流程
              }).then((canvas) => {
                  const url = canvas.toDataURL();
                  printJS({
                      printable: url, // 要打印的id
                      type: 'image',
                      style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;}' // 去除页眉页脚
                  });
              });
          },
      }
  };
  </script>
<style lang="scss" scoped>
.title{
    font-size:28px;
    margin-bottom: 12px;
}
</style>
